export default __webpack_public_path__ + "static/media/product19.81e1dfc9.png";